import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { WHATSAPP_MAIN_LINK, buildWhatsAppLink } from "./data";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PartnerContext = createContext({
  whatsappLink: WHATSAPP_MAIN_LINK,
  partnerCode: null,
  partnerName: null,
});

export const usePartner = () => useContext(PartnerContext);

export const PartnerProvider = ({ children }) => {
  const [state, setState] = useState({
    whatsappLink: WHATSAPP_MAIN_LINK,
    partnerCode: null,
    partnerName: null,
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    const wa = params.get("wa");
    const path = window.location.pathname.replace(/\/+$/, "");

    // 0) Fester TikTok-Affiliate-Link (/tiktok) → feste Nummer
    if (path === "/tiktok") {
      setState({ whatsappLink: buildWhatsAppLink("491709445427"), partnerCode: "tiktok", partnerName: "TikTok" });
      return;
    }

    // 1) Direkte Nummer im Link (?wa=...)
    if (wa) {
      setState({ whatsappLink: buildWhatsAppLink(wa), partnerCode: null, partnerName: null });
      return;
    }

    // 2) Partner-Kürzel (?ref=...) → Nummer vom Backend holen
    if (ref) {
      axios
        .get(`${API}/partners/${encodeURIComponent(ref)}`)
        .then((res) => {
          setState({
            whatsappLink: buildWhatsAppLink(res.data.whatsapp),
            partnerCode: res.data.code,
            partnerName: res.data.name,
          });
        })
        .catch(() => {
          // Unbekannter Partner → Haupt-Kurzlink
          setState({
            whatsappLink: WHATSAPP_MAIN_LINK,
            partnerCode: null,
            partnerName: null,
          });
        });
    }
  }, []);

  return <PartnerContext.Provider value={state}>{children}</PartnerContext.Provider>;
};
